// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ad1f30a1","952":"3a1bab0e"}[chunkId] + ".chunk.js";
};